import { render } from "./panoramicWindow.vue?vue&type=template&id=71e87f4b"
import script from "./panoramicWindow.vue?vue&type=script&lang=js"
export * from "./panoramicWindow.vue?vue&type=script&lang=js"

import "./panoramicWindow.vue?vue&type=style&index=0&id=71e87f4b&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__